import React, {useState} from 'react'
import {DataGrid, GridRowId, GridRowSelectionModel, deDE} from '@mui/x-data-grid';
import EditContactDialog from "./dialogs/EditContactDialog";
import ConfirmationDialog from "./dialogs/ConfirmationDialog";
import useContactsStore from "../../stores/useContactsStore";
import useGetContactsQuery from "../../queries/useGetContactsQuery";
import useGetGridColumns from "../../hooks/useGetGridColumns";
import TableToolbar from "./TableToolbar";


const ContactTable = () => {

    const {contacts} = useContactsStore();

    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);

    const {isLoading} = useGetContactsQuery();

    const columns = useGetGridColumns();

    const onRowsSelectionHandler = (ids: GridRowId[]) => {
        setRowSelectionModel(ids)
        // const selectedRowsData = ids.map((id) => rows.find((row) => row.id === id));
        // setSelectedRows(selectedRowsData);
    }

    if (isLoading) return (<p>Loading...</p>)

    return (
        <>
            <DataGrid
                localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                sx={{minWidth: "1204px",
                    minHeight: "36vh",
                    marginVertical: 1,
                    '.MuiDataGrid-columnHeaderTitle': {
                        color: "secondary.dark",
                        fontWeight: 'bold'
                    }
            }}
                onRowSelectionModelChange={(ids: GridRowId[]) => onRowsSelectionHandler(ids)}
                rowSelectionModel={rowSelectionModel}
                checkboxSelection
                slots={{
                    toolbar: TableToolbar,
                }}
                slotProps={{
                    toolbar: {rowSelectionModel, setRowSelectionModel},
                }}
                rowHeight={40}
                rows={contacts.filter(contact => contact.name.toLowerCase() !== "support")}
                getRowId={contact => contact.name}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {pageSize: 10, page: 0}
                    }
                }}
                pageSizeOptions={[5, 10, 25]}
            />

            <EditContactDialog/>
            <ConfirmationDialog/>
        </>
    );
}


export default ContactTable;